module.exports = __webpack_public_path__ + "img/业务.d17d161d.svg";